import React from 'react';
import { compose, setPropTypes, pure } from 'recompose';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  },
  leftIcon: {
    padding: '0px 5px'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired,
  deposits: PropTypes.arrayOf(
    PropTypes.shape({
      gochiBillId: PropTypes.number,
      groupName: PropTypes.string,
      shopName: PropTypes.string,
      gochiDate: PropTypes.string,
      amount: PropTypes.number,
      taxAmount: PropTypes.number,
      feeAmount: PropTypes.number,
      stripeFeeAmount: PropTypes.number,
      secretariatFeeAmount: PropTypes.number,
      depositAmount: PropTypes.number,
      depositDate: PropTypes.string,
      depositStatus: PropTypes.string,
      secretariatDepositAmount: PropTypes.number,
      secretariatDepositDate: PropTypes.string,
      secretariatDepositStatus: PropTypes.string,
      coupons: PropTypes.arrayOf(
        PropTypes.shape({
          couponId: PropTypes.number,
          menuName: PropTypes.string,
          price: PropTypes.number,
          taxType: PropTypes.string,
          displayName: PropTypes.string,
          useDate: PropTypes.string,
          expiration: PropTypes.string,
          message: PropTypes.string,
          gochiStatus: PropTypes.string
        })
      ).isRequired
    })
  ).isRequired
};

const enhance = compose(
  pure,
  setPropTypes(propTypes)
);

const DepositTableBody = enhance(
  ({ deposits, emptyRows, page, rowsPerPage, order, orderBy, roles }) => {
    let sortedResult;
    if (orderBy === 'menu') {
      sortedResult = _.orderBy(
        deposits,
        deposit => {
          return deposit.coupons[0].menuName;
        },
        order
      );
    } else if (orderBy === 'fee') {
      sortedResult = _.orderBy(
        deposits,
        ['feeAmount', 'stripeFeeAmount', 'secretariatFeeAmount'],
        [order, order, order]
      );
    } else {
      sortedResult = _.orderBy(deposits, orderBy, order);
    }
    return (
      <TableBody>
        {sortedResult
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map(deposit => {
            const key = `${deposit.gochiBillId}-${deposit.groupId}`;
            return (
              <TableRow key={key}>
                {(roles.isGroup ||
                  roles.isSecretariat ||
                  roles.isDeveloper) && (
                  <TableCell>{deposit.groupName}</TableCell>
                )}
                <TableCell>{deposit.shopName}</TableCell>
                <TableCell>{deposit.depositDate}</TableCell>
                <TableCell>{deposit.gochiDate}</TableCell>
                <TableCell>{deposit.depositStatusStr}</TableCell>
                <TableCell>{deposit.gochiTypeStr}</TableCell>
                <TableCell>
                  {deposit.coupons &&
                    deposit.coupons.map(coupon => {
                      return (
                        <div key={coupon.counponId}>
                          {coupon.menuName}
                          {`（`}
                          {coupon.gochiStatus}
                          {` / `}
                          {coupon.useDate}
                          {`）`}
                        </div>
                      );
                    })}
                </TableCell>
                <TableCell>{deposit.depositAmount}</TableCell>
                <TableCell>
                  {deposit.amount + deposit.taxAmount}
                  {`（`}
                  {deposit.amount}
                  {`）`}
                </TableCell>
                {(roles.isSecretariat || roles.isDeveloper) && (
                  <TableCell>
                    {deposit.feeAmount}
                    {`（`}
                    {deposit.stripeFeeAmount}
                    {` / `}
                    {deposit.secretariatFeeAmount}
                    {`）`}
                  </TableCell>
                )}
                {(roles.isSecretariat || roles.isDeveloper) && (
                  <TableCell>{deposit.secretariatDepositAmount}</TableCell>
                )}
                {(roles.isSecretariat || roles.isDeveloper) && (
                  <TableCell>{deposit.secretariatDepositDate}</TableCell>
                )}
                {(roles.isSecretariat || roles.isDeveloper) && (
                  <TableCell>{deposit.secretariatDepositStatusStr}</TableCell>
                )}
              </TableRow>
            );
          })}
        {emptyRows > 0 && (
          <TableRow style={{ height: 49 * emptyRows }}>
            <TableCell colSpan={7} />
          </TableRow>
        )}
      </TableBody>
    );
  }
);

export default withStyles(styles)(DepositTableBody);
